import React, { useState } from 'react';
import { Play } from 'lucide-react';

const VideoShowcase = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Video */}
          <div className="relative">
            {!isPlaying ? (
              <div 
                className="relative aspect-[9/16] max-w-md mx-auto rounded-2xl overflow-hidden shadow-2xl cursor-pointer group bg-gradient-to-br from-[#1e3a5f] to-[#48a9a6]"
                onClick={() => setIsPlaying(true)}
              >
                <img
                  src="https://i.ytimg.com/vi/iApvrZOrD7k/maxresdefault.jpg"
                  alt="Estúdio Hertz - Melhor estúdio de podcast de Brasília"
                  className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-20 h-20 bg-[#ff6b35] rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300 shadow-2xl">
                    <Play className="text-white ml-1" size={32} fill="white" />
                  </div>
                </div>
              </div>
            ) : (
              <div className="aspect-[9/16] max-w-md mx-auto rounded-2xl overflow-hidden shadow-2xl">
                <iframe
                  src="https://www.youtube.com/embed/iApvrZOrD7k?autoplay=1"
                  title="Estúdio Hertz - Gravação de podcasts e cursos online em Brasília"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                />
              </div>
            )}
          </div>

          {/* Text Content */}
          <div className="space-y-6 text-center md:text-left">
            <div className="inline-block">
              <span className="text-[#ff6b35] font-semibold text-sm uppercase tracking-wider bg-[#ff6b35]/10 px-4 py-2 rounded-full">
                Conheça Nosso Estúdio
              </span>
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] leading-tight">
              O melhor estúdio de podcast de Brasília
            </h2>
            
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p className="text-lg">
                Localizado no <strong>Palácio da Imprensa</strong>, no coração de Brasília, o Estúdio Hertz é referência em <strong>gravação de podcasts e cursos online em Brasília</strong>.
              </p>
              <p>
                Nossa estrutura audiovisual profissional inclui câmeras 4K, iluminação cinematográfica, tratamento acústico impecável e uma equipe especializada em produção de conteúdo.
              </p>
              <p>
                Se você procura um <strong>estúdio audiovisual em Brasília</strong> com qualidade premium para gravar seu podcast, curso online, videoclipe ou qualquer projeto audiovisual, este é o lugar certo.
              </p>
            </div>

            <div className="pt-4 flex justify-center md:justify-start">
              <button
                onClick={() => window.open('https://wa.me/5561985533770', '_blank')}
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#ff6b35] to-[#ff8555] text-white font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Agendar Visita ao Estúdio
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoShowcase;